
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-group-I-mock-interview",
      function () {
        return require("private-next-pages/tnpsc-group-I-mock-interview/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-group-I-mock-interview"])
      });
    }
  